import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { useUI } from "../constants/i18n";

const Footer: React.FC = () => {
  const { lang } = useLanguage();
  const ui = useUI(lang);

  return (
    <footer className="container mx-auto px-4 sm:px-6 lg:px-8 bg-[#000000] py-4 flex justify-start">
      <div className="text-white">
        <p>{ui.tagline}</p>
      </div>
    </footer>
  );
};

export default Footer;
